import React from "react";
import { useQuery } from "@apollo/client/react";

import { FETCH_PROJECT_QUERY } from "../constants/graphql/queries";
import { fetchSettings } from "../contexts/customFields";
import { useProject } from "./project";

export const useCustomProjectFields = (props = {}) => {
  const currentProject = useProject();

  const { data: { project = {} } = {} } = useQuery(FETCH_PROJECT_QUERY, {
    variables: { id: props.projectId },
    skip: !props.projectId || !Number(props.projectId),
  });

  if (props.projectId && props.projectId !== currentProject.id) {
    return fetchSettings(project);
  } else {
    return fetchSettings(currentProject);
  }
};

export const useProjectSettings = (props = {}) => {
  const currentProject = useProject();

  const { data: { project = {} } = {}, loading } = useQuery(FETCH_PROJECT_QUERY, {
    variables: { id: props.projectId },
    skip: !props.projectId || !Number(props.projectId),
  });

  if (props.projectId && props.projectId !== currentProject.id) {
    return [fetchSettings(project), loading];
  } else {
    return [fetchSettings(currentProject), false];
  }
};
